import React, { useState } from "react";
import { useSiteContent } from "../../context/SiteContentContext";

// "ขั้นตอนถัดไป" — tells the customer how to reach the admin (pay / send slip / ask about approval).
// Contact channels come from the editable "05 ติดต่อเรา" section, texts from "หน้าติดตามสถานะ".
const STEP_TEXT = {
  submitted: ["nextSubmittedTitle", "nextSubmittedText"],
  paid: ["nextPaidTitle", "nextPaidText"],
  rejected: ["nextRejectedTitle", "nextRejectedText"],
};

function lineMessageUrl(lineId, lineUrl, text) {
  // LINE Official Account: open a chat with the message already typed
  const id = String(lineId || "").trim();
  if (!id) return lineUrl || "";
  return `https://line.me/R/oaMessage/${encodeURIComponent(id)}/?${encodeURIComponent(text)}`;
}

function ContactAdminBox({ trackingCode, status = "submitted" }) {
  const { siteContent } = useSiteContent();
  const contact = siteContent.homeContact || {};
  const texts = siteContent.statusPage || {};
  const [copied, setCopied] = useState(false);

  const [titleKey, textKey] = STEP_TEXT[status] || STEP_TEXT.submitted;
  const message = `เลขติดตามประกาศ ${trackingCode}\n${status === "submitted" ? "ขอส่งหลักฐานการชำระเงินค่าลงประกาศ" : "ขอสอบถามสถานะประกาศ"}`;
  const phoneHref = `tel:+66${String(contact.phone || "").replace(/\D/g, "").replace(/^0/, "")}`;
  const mailHref = `mailto:${contact.email || ""}?subject=${encodeURIComponent(`ประกาศเลขติดตาม ${trackingCode}`)}&body=${encodeURIComponent(message)}`;

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(trackingCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard blocked — the code is still visible to copy by hand */
    }
  };

  return (
    <section className="next-step" aria-label="ขั้นตอนถัดไป">
      <p className="eyebrow">{texts.nextEyebrow || "NEXT STEP"}</p>
      <h3>{texts[titleKey]}</h3>
      <p>{texts[textKey]}</p>

      <div className="next-step-code">
        <span>เลขติดตาม</span>
        <strong>{trackingCode}</strong>
        <button type="button" className="text-link" onClick={copyCode}>
          {copied ? "คัดลอกแล้ว ✓" : "คัดลอก"}
        </button>
      </div>

      <div className="next-step-actions">
        {(contact.lineId || contact.lineUrl) && (
          <a className="button dark" href={lineMessageUrl(contact.lineId, contact.lineUrl, message)} target="_blank" rel="noreferrer">
            {status === "submitted" ? texts.nextLineSlipLabel : texts.nextLineAskLabel} {contact.lineId}{" "}
            <span>↗</span>
          </a>
        )}
        {contact.phone && (
          <a className="button outline" href={phoneHref}>
            {texts.nextPhoneLabel} {contact.phone}{" "}
            <span>↗</span>
          </a>
        )}
        {contact.email && (
          <a className="text-link" href={mailHref}>
            {texts.nextEmailLabel} {contact.email}{" "}
            <span>↗</span>
          </a>
        )}
      </div>

      {contact.hours && (
        <p className="next-step-hours">
          {contact.hours}
          {contact.hoursNote ? ` · ${contact.hoursNote}` : ""}
        </p>
      )}
    </section>
  );
}

export default ContactAdminBox;
